import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { useSelector } from 'react-redux';
import { ReduxState } from '../redux';
import Button from './Button';
import { DashboardCard, ConfirmationCard, CardHeader, CardTitle, CardButtonGroup } from './Card';
import { History } from 'history';
const { fonts, colors } = themes;

const ConfirmCard = styled(ConfirmationCard)`
  background: ${colors.KBPaleYellow};
  width: initial;
  max-width: initial;
`;

const DashCard = styled(DashboardCard)`
  background: ${colors.KBPaleYellow};
`;

const Link = styled.a`
  display: flex;
  cursor: pointer;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  text-decoration: underline;
  justify-content: center;
  align-items: center;
  text-align: center;
  :hover {
    font-weight: bold;
  }
  font-size: 16px;
`;

const Text = styled.div`
  margin-bottom: 20px;
  ${fonts.FoundersGrotesk}
  font-size: 17px;
`;

interface ButtonGroupProps {
  anchorButtons?: boolean;
}

const ButtonGroup = styled(CardButtonGroup)`
  justify-content: ${(p: ButtonGroupProps) => (p.anchorButtons ? 'flex-end' : 'initial')};
  margin-top: ${(p: ButtonGroupProps) => (p.anchorButtons ? 0 : '20px')};
  padding-bottom: 9px;

  button {
    text-transform: uppercase;
    ${fonts.FoundersGrotesk}
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

type Props = {
  confirmation?: boolean;
  history: History;
  isGyn?: boolean;
};

export default function IntakeFormCard(props: Props) {
  const { confirmation, history, isGyn } = props;
  const patientGender = useSelector<ReduxState>(state => state.patient.patient.gender);
  const isMale = patientGender == 'male' ? true : false;
  const maleIntakeForm = isMale ? '?male=true' : '';
  const gynAppointment = isGyn ? '?appointment=gyn' : '';
  const goToIntakeForm = () => {
    if (isMale) {
      window.location.href = `/patient-intake${maleIntakeForm}`;
    } else {
      window.location.href = `/patient-intake${gynAppointment}`;
    }
  };
  const goToDashboard = (event: MouseEvent) => {
    event.preventDefault();
    history.push('/');
  };

  const Wrapper = confirmation ? ConfirmCard : DashCard;
  return (
    <Wrapper>
      <Content>
        <CardHeader confirmation={confirmation}>Next step:</CardHeader>
        <CardTitle confirmation={confirmation}>
          Complete your <br />
          intake form
        </CardTitle>
        <Text>
          Please complete before you come in for your assessment so we can personalize your
          experience.
        </Text>
        <ButtonGroup anchorButtons={confirmation}>
          <Button type="submit" label="Fill out intake form" onClick={goToIntakeForm} />
        </ButtonGroup>
        {confirmation && <Link onClick={goToDashboard}>Go to dashboard</Link>}
      </Content>
    </Wrapper>
  );
}
